<mat-card appearance="outlined">
    <mat-card-header>
        <mat-icon class="card-header-icon" mat-card-avatar>person</mat-icon>
        <mat-card-title>Developer</mat-card-title>
        <mat-card-subtitle>Developer Settings</mat-card-subtitle>
    </mat-card-header>
    <mat-card-actions>

    </mat-card-actions>
    <mat-card-content>
    </mat-card-content>
</mat-card>